import { ACMEResponse } from '@b2b/types/core';
import angular, { IPromise } from 'angular';

export interface CustomerFeeConfig {
  id?: number;
  name: string;
  type?: string;
  presentmentType: 'PRECHECK' | 'OPTIONAL';
  salesChannels?: { id: number }[];
  percentage: string | number;
  fixed: string | number;
  inputLabel: string;
  tooltipLabel: string;
  refundable: boolean;
  active: boolean;
}

export class CustomerFeesApiService {
  static $inject = ['$http'];

  service = '/v1/customer/fees/configs';

  constructor(private $http: ng.IHttpService) {}

  init(endpoint: string) {
    this.service = endpoint + '/customer/fees/configs';
    return this;
  }

  list(): IPromise<{ data: ACMEResponse<{ list: CustomerFeeConfig[] }> }> {
    return this.$http<ACMEResponse<{ list: CustomerFeeConfig[] }>>({ method: 'get', url: this.service });
  }

  create(data: CustomerFeeConfig): IPromise<{ data: ACMEResponse<CustomerFeeConfig> }> {
    return this.$http<ACMEResponse<CustomerFeeConfig>>({ method: 'post', url: this.service, data });
  }

  update(id: number, data: CustomerFeeConfig): IPromise<{ data: ACMEResponse<CustomerFeeConfig> }> {
    return this.$http<ACMEResponse<CustomerFeeConfig>>({ method: 'put', url: `${this.service}/${id}`, data });
  }
}

export const CustomerFeesApiServiceModule = angular
  .module('acme.common.service.customerFeesApi', [])
  .service('CustomerFeesApiService', CustomerFeesApiService).name;
